// Override Boostrap variables
@import "../variables";
@import "node_modules/bootstrap/scss/mixins";
@import "node_modules/@coreui/coreui-pro/scss/variables";
